let tabs, panels;

function activateTab(tabId) {
  tabs.forEach((tab) => {
    tab.classList.toggle("active", tab.dataset.tab === tabId);
  });

  panels.forEach((panel) => {
    panel.classList.toggle("active", panel.id === tabId);
  });
}

function getTabFromHash() {
  const hash = window.location.hash.replace("#", "");
  const tabExists = [...tabs].some((tab) => tab.dataset.tab === hash);
  return tabExists ? hash : tabs[0].dataset.tab;
}

function handleInitialTab() {
  const initialTab = getTabFromHash();
  activateTab(initialTab);
}

document.addEventListener("DOMContentLoaded", () => {
  tabs = document.querySelectorAll(".tab");
  panels = document.querySelectorAll(".tab-panel");

  // Tab button clicks
  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const tabId = tab.dataset.tab;
      activateTab(tabId);
      history.replaceState(null, "", `#${tabId}`);
    });
  });

  // Anchor <a href="#tab"> clicks
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", (e) => {
      const target = anchor.getAttribute("href").replace("#", "");
      const isTab = document.querySelector(`.tab[data-tab="${target}"]`);

      if (isTab) {
        e.preventDefault();
        activateTab(target);
        history.replaceState(null, "", `#${target}`);

        // Smooth scroll if data-tab-scroll attribute is present
        if (anchor.hasAttribute("data-tab-scroll")) {
          const tabPanel = document.querySelector(`#${target}`);

          if (tabPanel) {
            tabPanel.scrollIntoView({
              behavior: "smooth",
            });
          }
        }
      }
    });
  });

  // Activate on load
  handleInitialTab();
});
